// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectRicsStandardsQueryResult, selectRicsStandardsPageLoading, selectRicsStandardsShowInitWaitingMessage} from '../_selectors/rics-standard.selectors';

export class RicsStandardsDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectRicsStandardsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectRicsStandardsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectRicsStandardsQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
